module.exports = __webpack_public_path__ + "static/img/小管家（官网）.80f5dafb.jpg";